import { render, staticRenderFns } from "./DashboardListState.vue?vue&type=template&id=38860664"
import script from "./DashboardListState.vue?vue&type=script&lang=js"
export * from "./DashboardListState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports